export default {
  data() {
    return {
      timeObj: {
        day: '0',
        hou: '00',
        min: '00',
        sec: '00'
      },
      countDownInterval: null
    }
  },
  methods: {
    timeFormat(param) {
      return param < 10 ? '0' + param : param;
    },
    /**
     * 倒计时
     * @param endTime
     */
    countDown(timestamp) {
      let time = timestamp
      this.countDownInterval = setInterval(() => {
        // 获取当前时间，同时得到活动结束时间数组
        let newTime = new Date().getTime();
        // 对结束时间进行处理渲染到页面
        let endTime = new Date(time).getTime();
        if(newTime >= endTime) {
          clearInterval(this.countDownInterval);
          this.countDownEnd()
        }
        let obj = null;
        // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt(time % (60 * 60 * 24) / 3600);
          let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
          let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
          obj = {
            day: day,
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };
        } else { // 活动已结束，全部设置为'00'
          obj = {
            day: '0',
            hou: '00',
            min: '00',
            sec: '00'
          };
          clearInterval(this.countDownInterval);
        }
        this.timeObj = obj
      }, 1000);
    },
    /*根据倒计时算时间*/
    handleTime() {
      let newTime = new Date(this.item.nowDateTime.replace(/-/g, '/')).getTime();
      let endTime = new Date(this.item.liveTime.replace(/-/g, '/')).getTime();
      let time = endTime - newTime
      this.countDownInterval = setInterval(() => {
        time = time - 1000
        let obj = null;
        if (time >= 1000) {
          obj = {
            day: parseInt(time / 1000 / 60 / 60 / 24),
            hou: this.timeFormat(parseInt(time / 1000 / 60 / 60 % 24, 10)),
            min: this.timeFormat(parseInt(time / 1000 / 60 % 60, 10)),
            sec: this.timeFormat(parseInt(time / 1000 % 60, 10))
          };
        } else { // 活动已结束，全部设置为'00'
          obj = {
            day: '0',
            hou: '00',
            min: '00',
            sec: '00'
          };
          clearInterval(this.countDownInterval);
        }
        this.timeObj = obj
      }, 1000);
    },
    countDownEnd() {
    }
  },
  beforeDestroy() {
    clearInterval(this.countDownInterval)
  }
}
